const translations = {
  "en": {
    "Do you really want to remove this asset?All associated transactions will also be removed.": "Do you really want to remove this asset? All associated transactions will also be removed.",
    "Remove from portfolio": "Remove from portfolio"
  },
  "zh-tw": {
    "Do you really want to remove this asset?All associated transactions will also be removed.": "你確定要移除此資產嗎？所有關聯的交易紀錄也將一併刪除。",
    "Remove from portfolio": "從投資組合中移除"
  }
};

export default translations;
